<template>
  <div class="container">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section section-celular">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="celular">
        <p v-show="!displayMsj" :class="{ displayNumberError: numberError }">{{ celularDisplay }}</p>
        <p v-show="displayMsj" :class="{ displayMsjError: displayError }">{{ celularMensaje }}</p>
      </div>
      <div class="teclado-cel">
        <div class="teclado-cel-row">
          <div id='1' @click='click' class="teclado-cel-col">1</div>
          <div id='2' @click='click' class="teclado-cel-col">2</div>
          <div id='3' @click='click' class="teclado-cel-col">3</div>
        </div>
        <div class="teclado-cel-row">
          <div id='4' @click='click' class="teclado-cel-col">4</div>
          <div id='5' @click='click' class="teclado-cel-col">5</div>
          <div id='6' @click='click' class="teclado-cel-col">6</div>
        </div>
        <div class="teclado-cel-row">
          <div id='7' @click='click' class="teclado-cel-col">7</div>
          <div id='8' @click='click' class="teclado-cel-col">8</div>
          <div id='9' @click='click' class="teclado-cel-col">9</div>
        </div>
        <div class="teclado-cel-row">
          <div id='clear' @click='click' class="teclado-cel-col">Clear</div>
          <div id='0' @click='click' class="teclado-cel-col">0</div>
          <div id='delete' @click='click' class="teclado-cel-col">Del</div>
        </div>
      </div>
      <b-button :class="{ link: true, 'button-loading': saving }"
        @click.prevent="save">ENVIAR</b-button>
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
    <div v-show="saving" class="spinner">
      <b-spinner small />
    </div>    
  </div>
</template>

<script>
export default {
  data () {
    return {
      evento: null,
      participante: null,

      displayMsj: true,
      displayError: false,

      celularCodigoArea: '',
      celularNumero: '',
      celularNumeroCompleto: '',
      celularDisplay: '',
      celularMensaje: 'Ingrese el nro de celular',
      numberError: false,

      saving: false,
      error: false,
      errorMessage: ''
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }
      /* Recuperamos la info del evento */
      var evento = this.$store.getters['eventos/evento'];
      if (evento) {
        this.evento = evento.nombre;
        /* Recuperamos la info del participante */
        var participante =  this.$store.getters['participante/participante'];
        if (participante) {
          this.participante = this.$store.getters['participante/nombreCompleto'];
        } else {
          this.$router.push({ name: 'SeleccionMetodo' });
        }
      } else {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }
  },
  methods: {
    save () {
      this.error = false;
      this.errorMessage = '';

      if (this.saving) {
        return;
      }

      if (this.celularNumero.trim() != '' && this.celularCodigoArea.trim() != '' ) {
        if (isNaN(this.celularNumeroCompleto)) {
          this.error = true;
          this.errorMessage = 'Ingrese solo digitos numéricos';
          return;
        } 
        if (!isFinite(this.celularNumeroCompleto)) {
            this.error = true;
            this.errorMessage = 'Ingrese solo digitos numéricos';
            return;
        }
        /* Validamos la longitud del nro */
        if (this.celularNumeroCompleto.length != 10) {
            this.error = true;
            this.errorMessage = 'Verifique el nro ingresado';
            return;
        }
        /* Validamos que no empiece con 0 (deberiamos validar el 15) */    
        if (this.celularCodigoArea.slice(1, 1) == '0') {
            this.error = true;
            this.errorMessage = 'Ingrese el código de área sin el prefijo 0';
            return;
        }
        if (isNaN(this.celularNumero)) {
          this.error = true;
          this.errorMessage = 'Ingrese solo digitos numéricos';
          return;
        } 
        if (!isFinite(this.celularNumero)) {
            this.error = true;
            this.errorMessage = 'Ingrese solo digitos numéricos';
            return;
        }
        /* Validamos que no empiece 15 */    
        if (this.celularNumero.slice(1, 2) == '15') {
            this.error = true;
            this.errorMessage = 'Ingrese el número sin el prefijo 15';
            return;
        }

        var params = {
          celularNumero: this.celularNumero,
          celularCodigoArea: this.celularCodigoArea
        }

        this.saving = true;
        this.$store.dispatch('participante/save', params)
          .then(response => {
            this.$router.push({ name: 'Confirmacion' });
            this.saving = false;
          })
          .catch( error => {
            // console.log(error);
            this.error = true;
            this.errorMessage = error;
            this.saving = false;
          });
      } else {
        this.celularMensaje = 'Ingrese el nro de celular';
        this.displayMsj = true;
        this.displayError = true;
      }
    },
    back () {
      this.$router.go(-1);
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    },
    click(event) {
      if (event) {
        if (event.srcElement) {
          if (this.displayMsj) {
            this.celularNumeroCompleto = '';
            this.celularDisplay = '';
            this.displayMsj = false;
            this.displayError = false;
          }

          if (event.target.innerText == 'Clear') {
            this.celularNumeroCompleto = '';
            this.celularDisplay = '';
            this.celularNumero = '';
            this.celularCodigoArea = '';
            this.ingresandoCodigoArea = true;
          } else if (event.target.innerText == 'Del') {
            this.celularNumeroCompleto = this.celularNumeroCompleto.substring(0, this.celularNumeroCompleto.length - 1);
          } else {
            this.celularNumeroCompleto += event.target.innerText;
          }

          this.numberError = false;
          this.error = false;
          this.errorMessage = '';
          var long = this.celularNumeroCompleto.length;
          if (long <= 2) {
            this.celularCodigoArea = this.celularNumeroCompleto;
            this.celularNumero = '';

            this.celularDisplay = this.celularNumeroCompleto;
          } else if (long <= 6) {
            this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 2);
            this.celularNumero = this.celularNumeroCompleto.substring(2);

            this.celularDisplay = this.celularCodigoArea  + ' - ' + this.celularNumero;
          } else if (long <= 7) {
            if (this.celularNumeroCompleto.substring(0, 2) == '11') {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 2);
              this.celularNumero = this.celularNumeroCompleto.substring(2);
            } else {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 3);
              this.celularNumero = this.celularNumeroCompleto.substring(3);
            }

            this.celularDisplay = this.celularCodigoArea  + ' - ' + this.celularNumero;
          } else if (long <= 8) {
            if (this.celularNumeroCompleto.substring(0, 2) == '11') {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 2);
              this.celularNumero = this.celularNumeroCompleto.substring(2);
            } else {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 4);
              this.celularNumero = this.celularNumeroCompleto.substring(4);
            }

            this.celularDisplay = this.celularCodigoArea  + ' - ' + this.celularNumero;
          } else if (long <= 10) {
            if (this.celularNumeroCompleto.substring(0, 2) == '11') {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 2);
              this.celularNumero = this.celularNumeroCompleto.substring(2);
            } else {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 3);
              this.celularNumero = this.celularNumeroCompleto.substring(3);
            }

            this.celularDisplay = '(' + this.celularCodigoArea   + ') '
              + this.celularNumero.substring(0, 3)
              + ' - ' + this.celularNumero.substring(3);
          } else {
            if (this.celularNumeroCompleto.substring(0, 2) == '11') {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 2);
              this.celularNumero = this.celularNumeroCompleto.substring(2);
            } else {
              this.celularCodigoArea = this.celularNumeroCompleto.substring(0, 3);
              this.celularNumero = this.celularNumeroCompleto.substring(3);
            }

            this.celularDisplay = this.celularCodigoArea + this.celularNumero;
            this.numberError = true;
          }

          /*
          console.log('Long: ' + long + ' - Full: ' + this.celularNumeroCompleto
            + ' - Cod Area: ' + this.celularCodigoArea
            + ' - Numero:' + this.celularNumero);
          */
        }
      }
    }
  },
}
</script>

<style scoped>
  div.spinner {
    position: relative;
    top: -20px;
  }
  div.spinner span{
    position: relative;
    left: 20px;
  }
  .button-loading {
    opacity: 0.2;
  }
</style>



// WEBPACK FOOTER //
// src/components/IngresoCelularTeclado.vue